<app-header></app-header>

<section>
	<div class="container py-5">
		<p><span translate>Login to your personal account is temporarily unavailable</span>...</p>
	</div>
</section>

<app-footer></app-footer>